import "../styles/Loader.css";

const Loader = () => {
  return (
    <div className="loader-container">
      <div class="loader">
        <span class="loader-block"></span>
        <span class="loader-block"></span>
        <span class="loader-block"></span>
        <span class="loader-block"></span>
        <span class="loader-block"></span>
        <span class="loader-block"></span>
        <span class="loader-block"></span>
        <span class="loader-block"></span>
        <span class="loader-block"></span>
      </div>
    </div>
  );
};

export default Loader;
